<template>
  <div
    ref="dropdownContainer"
    class="relative inline-block text-left"
  >
    <button
      type="button"
      class="border-[1px] shadow-[0px_1px_2px_0px_#0000001A] border-[#e5e7eb] !rounded-[8px] bg-white text-black flex items-center justify-center min-w-[80px] h-[36px] px-[12px] text-[14px] font-medium hover:bg-[#f9fafb] focus:outline-none transition-colors"
      @click="toggleDropdown"
    >
      Ubah
    </button>
    <div
      v-show="isOpen"
      class="absolute right-0 mt-[8px] min-w-[160px] bg-white border-[1px] border-[#e5e7eb] rounded-[8px] shadow-[0_10px_15px_-3px_rgba(0,0,0,0.1),0_4px_6px_-2px_rgba(0,0,0,0.05)] z-[50] py-[4px] px-[6px]"
    >
      <div
        class="relative"
        @mouseenter="onMouseEnter('status')"
        @mouseleave="onMouseLeave"
      >
        <button
          type="button"
          class="w-full flex justify-between items-center px-[12px] py-[8px] text-[14px] text-left transition-colors rounded-[6px]"
          :class="activeMenu === 'status' ? 'bg-[#FFF3EE]' : 'hover:bg-[#FFF3EE]'"
          @click.stop="toggleMenu('status')"
        >
          Status
          <feather-icon
            icon="ChevronRightIcon"
            size="16"
            class="ml-[16px]"
          />
        </button>
        <ul
          v-show="activeMenu === 'status'"
          class="fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-[100] bg-white border-[1px] border-[#e5e7eb] rounded-[12px] shadow-[0_20px_25px_-5px_rgba(0,0,0,0.1),0_10px_10px_-5px_rgba(0,0,0,0.04)] py-[6px] px-[8px] min-w-[240px] max-w-[90vw] list-none p-0 m-0 md:absolute md:top-0 md:right-full md:left-auto md:translate-x-0 md:translate-y-0 md:mr-[4px] md:min-w-[180px] md:rounded-[8px] md:shadow-[0_10px_15px_-3px_rgba(0,0,0,0.1),0_4px_6px_-2px_rgba(0,0,0,0.05)] md:py-[4px] md:px-[6px]"
          @click.stop
        >
          <li
            v-for="status in statuses"
            :key="status.value"
          >
            <button
              type="button"
              class="w-full flex items-center justify-between px-[12px] py-[10px] text-[14px] transition-colors rounded-[6px]"
              :class="selectedStatus === status.value ? 'bg-[#FFF3EE]' : 'hover:bg-[#f9fafb]'"
              @click="selectStatus(status.value)"
            >
              <span class="text-left max-w-[300px]">{{ status.label }}</span>
              <feather-icon
                v-if="selectedStatus === status.value"
                icon="CheckIcon"
                size="16"
                class="text-[#F15A24] ml-[12px] flex-shrink-0"
              />
            </button>
          </li>
        </ul>
      </div>

      <div
        class="relative"
        @mouseenter="onMouseEnter('kategori')"
        @mouseleave="onMouseLeave"
      >
        <button
          type="button"
          class="w-full flex justify-between items-center px-[12px] py-[8px] text-[14px] text-left transition-colors rounded-[6px]"
          :class="activeMenu === 'kategori' ? 'bg-[#FFF3EE]' : 'hover:bg-[#FFF3EE]'"
          @click.stop="toggleMenu('kategori')"
        >
          Kategori
          <feather-icon
            icon="ChevronRightIcon"
            size="16"
            class="ml-[16px]"
          />
        </button>
        <ul
          v-show="activeMenu === 'kategori'"
          class="fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-[100] bg-white border-[1px] border-[#e5e7eb] rounded-[12px] shadow-[0_20px_25px_-5px_rgba(0,0,0,0.1),0_10px_10px_-5px_rgba(0,0,0,0.04)] py-[6px] px-[8px] min-w-[240px] max-w-[90vw] list-none p-0 m-0 max-h-[280px] overflow-y-auto md:absolute md:top-0 md:right-full md:left-auto md:translate-x-0 md:translate-y-0 md:mr-[4px] md:min-w-[200px] md:rounded-[8px] md:shadow-[0_10px_15px_-3px_rgba(0,0,0,0.1),0_4px_6px_-2px_rgba(0,0,0,0.05)] md:py-[4px] md:px-[6px]"
          @click.stop
        >
          <li
            v-for="cat in categoriesWithDefault"
            :key="cat.id !== null ? cat.id : '__default__'"
          >
            <button
              type="button"
              class="w-full flex items-center justify-between px-[12px] py-[10px] text-[14px] transition-colors rounded-[6px]"
              :class="isSelectedCategory(cat) ? 'bg-[#FFF3EE]' : 'hover:bg-[#f9fafb]'"
              @click="selectCategory(cat)"
            >
              <span
                class="text-left max-w-[300px] truncate"
                :title="cat.name"
              >{{ cat.name }}</span>
              <feather-icon
                v-if="isSelectedCategory(cat)"
                icon="CheckIcon"
                size="16"
                class="text-[#F15A24] ml-[12px] flex-shrink-0"
              />
            </button>
          </li>
          <li v-if="isFetchingCategories">
            <span class="block px-[16px] py-[8px] text-[12px] text-[#9ca3af]">Memuat...</span>
          </li>
        </ul>
      </div>

      <div class="border-t-[1px] border-[#e5e7eb] my-[4px]" />

      <button
        type="button"
        class="w-full text-left px-[16px] py-[8px] text-[14px] text-[#E03A45] hover:bg-[#f9fafb] transition-colors"
        @click="emitAction('delete')"
      >
        Hapus Artikel
      </button>
    </div>
  </div>
</template>

<script>
import { createPaginatedFetcher } from '@/@core/libs/fetch/usePaginatedFetcher'

export default {
  data() {
    return {
      isOpen: false,
      activeMenu: null,
      selectedCategory: null,
      selectedStatus: null,
      categorySearch: '',
      categoryFetcher: null,
      statuses: [
        { value: 'publish', label: 'Publish' },
        { value: 'draft', label: 'Draft' },
        { value: 'hide', label: 'Hide' },
      ],
    }
  },
  computed: {
    categories() {
      return this.categoryFetcher?.data || []
    },
    categoriesWithDefault() {
      return this.categories
    },
    isFetchingCategories() {
      return this.categoryFetcher?.isLoading || false
    },
    hasNextPageCategory() {
      return this.categoryFetcher?.hasMore || false
    },
  },
  mounted() {
    // Close the dropdown whenever the user clicks outside this component
    document.addEventListener('click', this.handleClickOutside)
    // Initialize a cursor-based paginated fetcher for the categories list
    this.categoryFetcher = createPaginatedFetcher(async params => {
      const { data } = await this.$http_new.get('/live-chat/api/v1/categories/options', { params })
      return { data: data.data }
    })
    this.categoryFetcher.fetchData()
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleClickOutside)
  },
  methods: {
    toggleDropdown() {
      this.isOpen = !this.isOpen
      if (!this.isOpen) {
        this.activeMenu = null
      }
    },
    onMouseEnter(menu) {
      if (window.matchMedia('(hover: hover)').matches) {
        this.activeMenu = menu
      }
    },
    onMouseLeave() {
      if (window.matchMedia('(hover: hover)').matches) {
        this.activeMenu = null
      }
    },
    toggleMenu(menu) {
      this.activeMenu = this.activeMenu === menu ? null : menu
    },
    /**
     * Closes the dropdown when the user clicks outside the component root element.
     * @param {MouseEvent} e
     */
    handleClickOutside(e) {
      if (this.isOpen && this.$refs.dropdownContainer && !this.$refs.dropdownContainer.contains(e.target)) {
        this.isOpen = false
        this.activeMenu = null
      }
    },
    /**
     * Triggered when the category list sentinel element enters the viewport (infinite scroll).
     * Fetches the next page if more data is available.
     */
    onIntersectCategory() {
      if (this.categoryFetcher?.hasMore && !this.categoryFetcher.isLoading) {
        this.categoryFetcher.fetchData()
      }
    },
    /**
     * Selects a status value and immediately dispatches a bulk action to the parent.
     * @param {'publish'|'draft'|'hide'} value
     */
    selectStatus(value) {
      this.selectedStatus = value
      this.emitAction('status', value)
    },
    /**
     * Checks whether a given category is currently selected.
     * @param {{ id: number|null }} cat
     * @returns {boolean}
     */
    isSelectedCategory(cat) {
      if (!this.selectedCategory) return false
      return this.selectedCategory.id === cat.id
    },
    /**
     * Selects a category and immediately dispatches a bulk action to the parent.
     * A category with a null id is sent as null (i.e. "no category").
     * @param {{ id: number|null, name: string }} cat
     */
    selectCategory(cat) {
      this.selectedCategory = cat
      this.emitAction('category', cat.id !== null ? cat : null)
    },
    /**
     * Emits the 'bulk-action' event to the parent and resets the dropdown state.
     * @param {'status'|'category'|'delete'} action - The type of bulk action
     * @param {*} [payload=null] - Optional payload (status value, category object, etc.)
     */
    emitAction(action, payload = null) {
      this.$emit('bulk-action', { action, payload })
      this.isOpen = false
      this.activeMenu = null
      this.selectedCategory = null
      this.selectedStatus = null
    },
  },
}
</script>
